import { add as addRequest } from 'serviceWorker/db/httpRequests';
import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { InspectionTemplateHttpDeleteRequestModel } from '../httpQueue/inspectionTemplate/types';

export class InspectionTemplateRemover {
  constructor(
    private addRequest: (
      request: InspectionTemplateHttpDeleteRequestModel
    ) => Promise<unknown>
  ) {}

  async execute(
    templateId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    await this.addRequest({
      createdAt: Date.now(),
      method: 'DELETE',
      // `templateId` lets the outcome archive the template locally.
      data: {
        templateId,
        uniqueId,
      },
      url: `/project/${projectId}/inspectionTemplate/${templateId}`,
      entityType: HttpRequestModelType.inspectionTemplate,
      status: HttpRequestStatus.NEW,
    });
  }
}

export const inspectionTemplateRemover = new InspectionTemplateRemover(
  addRequest
);
